import { render, staticRenderFns } from "./useDetailed.vue?vue&type=template&id=066a7935&scoped=true"
import script from "./useDetailed.vue?vue&type=script&lang=js"
export * from "./useDetailed.vue?vue&type=script&lang=js"
import style0 from "./useDetailed.vue?vue&type=style&index=0&id=066a7935&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066a7935",
  null
  
)

export default component.exports